module.exports = __webpack_public_path__ + "img/kaist_gallery4.4b310c42.jpg";